module.exports = __webpack_public_path__ + "static/img/CA.2120ea42.png";